var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,0.000000) scale(3.076923) translate(-0.000000,-0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_1"
    }
  }, [_c('g', [_c('circle', {
    attrs: {
      "fill": "#69a4e2",
      "cx": "32",
      "cy": "32",
      "r": "32"
    }
  })]), _c('g', [_c('g', {
    attrs: {
      "opacity": "0.2"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#231F20",
      "d": "M49.5,22.3h-5c0,0-1.4,0-2.5-2.7c-0.5-1.4-1.1-2.7-2.5-2.7h-10c-1.4,0-2,1.3-2.5,2.7c-1,2.7-2.5,2.7-2.5,2.7 H22c0-1.5-1.1-2.7-2.5-2.7H17c-1.4,0-2.5,1.2-2.5,2.7c-1.4,0-2.5,1.2-2.5,2.7v21.3c0,1.5,1.1,2.7,2.5,2.7h35 c1.4,0,2.5-1.2,2.5-2.7V25C52,23.5,50.9,22.3,49.5,22.3z"
    }
  })]), _c('g', [_c('path', {
    attrs: {
      "fill": "#4F5D73",
      "d": "M49.5,20h-5c0,0-1.4,0.3-2.5-2.3c-0.5-1.4-1.1-2.7-2.5-2.7h-10c-1.4,0-2,1.3-2.5,2.7c-1,2.7-2.5,2.3-2.5,2.3 H22c0-1.5-1.1-2-2.5-2H17c-1.4,0-2.5,0.5-2.5,2c-1.4,0-2.5,1.5-2.5,3v21.3c0,1.5,1.1,2.7,2.5,2.7h35c1.4,0,2.5-1.2,2.5-2.7V23 C52,21.5,50.9,20,49.5,20z"
    }
  })]), _c('g', [_c('circle', {
    attrs: {
      "fill": "#77B3D4",
      "cx": "34",
      "cy": "33",
      "r": "9"
    }
  })]), _c('g', {
    attrs: {
      "opacity": "0.2"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "fill": "#231F20",
      "d": "M34,46c-6.1,0-11-4.9-11-11s4.9-11,11-11s11,4.9,11,11S40.1,46,34,46z M34,28c-3.9,0-7,3.1-7,7s3.1,7,7,7 s7-3.1,7-7S37.9,28,34,28z"
    }
  })])]), _c('g', [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M34,43.5c-5.8,0-10.5-4.7-10.5-10.5S28.2,22.5,34,22.5S44.5,27.2,44.5,33S39.8,43.5,34,43.5z M34,25.5 c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5S38.1,25.5,34,25.5z"
    }
  })])])]), _c('g', {
    attrs: {
      "id": "Layer_2"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }